import { useEffect, useState } from "react";
import { getConsent } from "@/lib/consent";

export const isStandalone = () =>
  window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone === true;

export const isIOS = () =>
  (/iphone|ipad|ipod/i.test(window.navigator.userAgent) && !window.MSStream) ||
  (window.navigator.platform === "MacIntel" && window.navigator.maxTouchPoints > 1);

export const isMovil = () => /android|iphone|ipad|ipod|mobile/i.test(window.navigator.userAgent);

const manifestActual = () =>
  document.querySelector('link[rel="manifest"]')?.getAttribute("href") === "/manifest-fichaje.json" ? "fichaje" : "general";

// En FICHAJE el banner espera a que se responda al aviso de cookies, para no taparse los dos abajo.
export function useConsentido() {
  const [consentido, setConsentido] = useState(() => !!getConsent());
  useEffect(() => {
    if (consentido) return;
    const i = setInterval(() => { if (getConsent()) setConsentido(true); }, 1000);
    return () => clearInterval(i);
  }, [consentido]);
  return consentido;
}

// El aviso del navegador corresponde al manifest activo en ese momento (NuvliPro o NuvliPro FICHAJE).
export function useAvisoInstalacion() {
  const [deferred, setDeferred] = useState(null);
  const [instalada, setInstalada] = useState(isStandalone);
  useEffect(() => {
    if (isStandalone()) return;
    if (window.__nvInstall) setDeferred(window.__nvInstall);
    const onPrompt = (e) => { e.preventDefault(); setDeferred({ e, v: manifestActual() }); };
    const onInstalled = () => { setInstalada(true); setDeferred(null); };
    window.addEventListener("beforeinstallprompt", onPrompt);
    window.addEventListener("appinstalled", onInstalled);
    return () => {
      window.removeEventListener("beforeinstallprompt", onPrompt);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  const instalar = async () => {
    if (!deferred) return;
    deferred.e.prompt();
    const { outcome } = await deferred.e.userChoice;
    if (outcome === "accepted") setInstalada(true);
    window.__nvInstall = null;
    setDeferred(null);
  };
  return { deferred, instalada, instalar };
}
